/*
* 検索結果の再検索エリアの表示
* -------------------------------------------------------------------
*/

$(function(){
  $(".show_area").click(function() {
    var ele = document.getElementById("area_search");
    if (getComputedStyle(ele).display == 'none'){
        $("#area_search").css("display", "block");
        $("#service_search").css("display", "none");
    }else{
        $("#area_search").css("display", "none");
        $("#service_search").css("display", "none");
    }
  });
  $(".show_service").click(function() {
    var ele = document.getElementById("service_search");
    if (getComputedStyle(ele).display == 'none'){
        $("#area_search").css("display", "none");
        $("#service_search").css("display", "block");
    }else{
        $("#area_search").css("display", "none");
        $("#service_search").css("display", "none");
    }
  });
});